import { oldApi } from '../lib/api';

export class PromoCodeApi {
  async submitPromoCode(id, promo = '') {
    return await oldApi.post(
      `/ApiPromo/apply_promo?order_id=${id}&promocode=${promo}`,
    );
  }
}
